// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import i18n from './locales'
import tab from './utils/tab'
import { VueAxios } from './utils/request'
import { dictDataList } from "@/api/system/dictData";
import { message, FormModel, AutoComplete } from 'ant-design-vue'
import ProLayout, { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
import themePluginConfig from '../config/themePluginConfig'
import directive from './directive'
import UploadImg from '@/components/Upload_img'

// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
// import './mock'

import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
import './global.less' // global style

Vue.prototype.getDicts = dictDataList
Vue.prototype.$message = message
Vue.prototype.$tab = tab
Vue.prototype.$have_Permisson = ((permission) => {
  const roles = store.getters.roles
  if (roles[0] === "*:*:*") {
    return true;
  } else {
    return roles.indexOf(permission) === -1 ? false : true;
  }
})

Vue.config.productionTip = false

Vue.use(directive)
Vue.use(AutoComplete)
Vue.use(FormModel)
// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)

// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)

Vue.component('UploadImg', UploadImg)

window.umi_plugin_ant_themeVar = themePluginConfig.theme

new Vue({
  router,
  store,
  i18n,
  // init localstorage, vuex, Logo message
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
